import React, { memo } from 'react'
import { Box } from '@mui/material'
import { Ellipse } from 'src/components/atoms'
import { tenantStatusMap } from 'src/domain/tenant'
import { TenantOwnerCompany, TenantStatusEnum } from 'src/slices/services/api'
import { formatDateTime } from 'src/utils/date'
import styles from './styles.module.scss'

export type HeaderProps = {
  tenantOwnerCompany?: TenantOwnerCompany
} & React.StyledProps

const Header: React.StyledFC<HeaderProps> = memo(
  ({ tenantOwnerCompany }: HeaderProps) => {
    return (
      <Box>
        <Box>
          <span className={styles.code}>{tenantOwnerCompany?.code}</span>
          <span className={styles.title}>{tenantOwnerCompany?.name}</span>
        </Box>
        <Box className={styles.statusContainer}>
          <Ellipse
            color={
              tenantOwnerCompany?.active
                ? tenantStatusMap[TenantStatusEnum.Ready].color
                : tenantStatusMap[TenantStatusEnum.Closed].color
            }
          />
          <span className={styles.status}>
            {tenantOwnerCompany?.active
              ? tenantStatusMap[TenantStatusEnum.Ready].title
              : tenantStatusMap[TenantStatusEnum.Closed].title}
          </span>
          <span className={styles.label}>最終更新日時</span>
          <span className={styles.updateAt}>
            {tenantOwnerCompany?.updatedAt
              ? formatDateTime(tenantOwnerCompany?.updatedAt)
              : '-'}
          </span>
        </Box>
      </Box>
    )
  }
)

Header.displayName = 'Header'
export default Header
